/**
 * File size and duration formatting utilities
 */

/**
 * Formats file size from KB to human-readable format
 * @param fileSizeInKB - File size in kilobytes
 * @returns Formatted file size string with appropriate units, or "--" if invalid
 * @example
 * formatFileSize(1024) // "1.00 MB"
 * formatFileSize(500) // "500 KB"
 * formatFileSize(0) // "--"
 */
export const formatFileSize = (fileSizeInKB: number): string => {
  if (
    !fileSizeInKB ||
    fileSizeInKB === 0 ||
    isNaN(fileSizeInKB) ||
    fileSizeInKB === -1
  )
    return "--";

  if (fileSizeInKB < 1024) {
    return `${fileSizeInKB} KB`;
  }
  const fileSizeInMB = fileSizeInKB / 1024;
  if (fileSizeInMB < 1024) {
    return `${fileSizeInMB.toFixed(2)} MB`;
  }
  const fileSizeInGB = fileSizeInMB / 1024;
  return `${fileSizeInGB.toFixed(2)} GB`;
};
